var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMendozaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 34,
    fill: "none",
    viewBox: "0 0 21 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#334443",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.387 32.995c-.85-.491-1.833-.598-2.737-.939-.27-.102-.602-.104-.76-.367-.425-.703-1.067-.74-1.79-.724-1.11.024-1.468-.225-1.838-1.263-.192-.543-.614-.782-1.05-1.025-.758-.42-1.138-1.174-1.671-1.76-.724-.795-.236-1.336-.261-2.007-.055-1.428-.156-2.873-1.149-4.044-.211-.25-.161-.453.108-.575.543-.246.7-.722.72-1.238.061-1.552.494-2.979 1.335-4.279.302-.468.418-.96.283-1.513-.274-1.127-.143-2.276-.165-3.416-.01-.486-.04-.915-.687-.94-.407-.017-.52-.344-.535-.676-.042-.926.022-1.86-.357-2.746-.117-.273.046-.452.327-.522.23-.06.456-.146.688-.191.64-.125 1.048-.326.633-1.104-.162-.304-.175-.764.093-1.066.647-.729 1.557-1.064 2.428-1.397.47-.178.745.254.887.703.152.48.274.98.939 1.028.698.05 1.175-.219 1.475-.843.352-.737 1.038-.942 1.758-1.07.27-.049.577-.028.708.243.402.833 1.147.745 1.857.729 1.14-.026 1.35.119 1.744 1.194.472 1.29.56 2.649.69 3.994.114 1.192.567 2.232 1.363 3.069.795.834 1.038 1.7.81 2.821-.197.97.206 1.883.652 2.732.819 1.559 1.269 3.181 1.067 4.96-.08.712-.123 1.43-.152 2.146-.02.493-.224.698-.729.72-1.986.086-3.97.21-5.956.307-.998.048-1.029.082-.78 1.074.501 2.001.611 4.038.55 6.093-.02.634-.08 1.279.142 1.897l-.64-.005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMendozaIcon);
export default __webpack_public_path__ + "static/media/mendozaIcon.e6b6f54e069dc5296022ad870879479b.svg";
export { ForwardRef as ReactComponent };